module.exports = __webpack_public_path__ + "static/media/logo.c915ea27.svg";